import { gql, useQuery } from '@apollo/client'

import {
  ArtistMembershipSubscriptionDetailFragmentDoc,
  DigitalMembershipCardDetailQuery,
  DigitalMembershipCardDetailQueryVariables,
} from '@/clients/utoniq-core/schema'
import { config } from '@/config'
import { useCurrentUser, useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { getActiveMembershipSubscriptionProductPlan } from '@/core/membership'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { userClaims, user: currentUser } = useCurrentUser()
  const { router } = useRouter<{ artistId: string }>()
  const artistId = router.query.artistId ?? config.artistId

  const { data, loading } = useQuery<
    DigitalMembershipCardDetailQuery,
    DigitalMembershipCardDetailQueryVariables
  >(QUERY, {
    variables: {
      artistId: artistId ?? '',
    },
    skip: !artistId,
  })

  const patron = getActiveMembershipSubscriptionProductPlan(
    data?.artist,
    data?.artist?.patron?.subscription?.planId
  )
  return {
    state: {
      loading,
      artist: data?.artist ?? null,
      currentUser: currentUser ?? null,
      patron: patron ?? null,
    },
    actions: {},
  }
})

const QUERY = gql`
  query DigitalMembershipCardDetail($artistId: ID!) {
    artist(id: $artistId) {
      id
      displayName
      avatar {
        uri
      }
      ...ArtistMembershipSubscriptionDetail
      patron {
        createdAt
        user {
          displayName
        }
        subscription {
          planId
        }
        favoriteMember {
          createdAt
        }
        userDigitalMembershipCard {
          cardDesignPath
          textColor
          displayAreaColor
        }
        formattedMembershipNumber
      }
    }
  }
  ${ArtistMembershipSubscriptionDetailFragmentDoc}
`
